// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1d8cbfe4","693":"952cedc8"}[chunkId] + ".chunk.js";
};